import { REGIONS_LIST } from "../../constants/regions";
import { getLineupSlug } from "../../utils/path/library";

export const REGIONS_VISIBLE_IN_NAV = REGIONS_LIST.filter(
    (region) => !region.hideInNav
).map(({ path, title, shortTitle, link }) => {
    return {
        title,
        shortTitle,
        link,
        lineupID: path.replace(/[^\w]/g, ""),
        lineupSlug: getLineupSlug(path),
    };
});
